module.exports = __webpack_public_path__ + "static/media/reviewer-person.282ab1e1.svg";